import store from '../../store/store';
import { action } from 'satcheljs/lib/legacy';
/**
 * Set the InboxRuleDiagnosticRequestStatus in the inbox rules options store
 * @param requestStatus the get inbox rules diagnostic request status to set
 */
export default action('setInboxRuleDiagnosticRequestStatus')(function setInboxRuleDiagnosticRequestStatus(requestStatus) {
    store.inboxRulesListState.getInboxRuleDiagnosticRequestStatus = requestStatus;
});
//# sourceMappingURL=setInboxRuleDiagnosticRequestStatus.js.map